if (!customElements.get('bn-product-card-specs')) {
  customElements.define(
    'bn-product-card-specs',
    class BnProductCardSpecs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.addEventListener('mouseenter', () => this.scrollToEnd());
        this.addEventListener('mouseleave', () => this.scrollToStart());
        this.dataset.initialized = 'true';
      }

      scrollToEnd() {
        const maxScroll = this.scrollWidth - this.clientWidth;
        if (this.reducedMotion.matches || maxScroll <= 0) return;
        this.scrollTo({ left: maxScroll, behavior: 'smooth' });
      }

      scrollToStart() {
        this.scrollTo({ left: 0, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
    }
  );
}
